import { ReactNode, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

interface Props {
    text: string;
    children: ReactNode | ReactNode[];
    isOpen: boolean;
}

export default function MenuGroup({ text, children, isOpen }: Props) {
    const [isMenuGroupOpen, setIsMenuGroupOpen] = useState(isOpen);

    return (
        <li key={new Date().getMilliseconds().toString()} className='nav-item'>
            <Link
                className='nav-link menu-link text-selected'
                data-bs-toggle='collapse'
                to='#'
                onClick={(e) => {
                    setIsMenuGroupOpen(!isMenuGroupOpen);
                }}
            >
                <i className='bx bx-layer'></i>
                <span data-key='t-apps' className='text-selected'>
                    {text}
                </span>
            </Link>
            <div
                id={new Date().getMilliseconds().toString()}
                className={`menu-dropdown collapse ${isMenuGroupOpen ? 'show' : ''}`}
            >
                <ul className='nav nav-sm flex-column test'>{children}</ul>
            </div>
        </li>
    );
}
